import $ from "../../$.js";
import ApiServer from "../../ApiServer.js";
import * as FwDatas from "../../FwDatas.ts";
import * as Html from "../../util/Html.ts";
import {Searcher} from "../../lib/searchString.js";
import { TaskCategoryCache ,TaskListCache } from "../../server/objects/TaskBeans.ts";

const SuggestionBuilder = {
    getPromise(listType){
      if(this[listType]) return this[listType];
      return (this[listType] = new Promise(function(resolve, reject) {
        ApiServer.taskgettasksuggestionswcat(listType,null,null, function(items){
          let familyId = FwDatas.getFamily().family_id;
          items.suggestions.forEach(sugg=>sugg.taskCategoryId = "taskCategory/"+familyId+"_"+sugg.categoryId);
          resolve(items.suggestions);
        },reject)
      }))
    }
}
class TaskSuggestionSet{
  constructor(){
    this.data = [];
    this.keys = {};
  }
  push(item){
    let key = (item.value+'|'+item.taskCategoryId);
    if(this.keys[key]) return;
    this.data.push(item);
    this.keys[key]=item;
  }
  pushAll(itemArray){
    itemArray.forEach(item=>this.push(item));
  }
}
const datasource = {
    suggestions:function(metaId){
      return SuggestionBuilder.getPromise(FwDatas.get(metaId).taskListType);
    },
    sametype:function(metaId){
      const 
        currentList = TaskListCache.get(metaId),
        currentType = currentList.taskListType,
        result = [];
      
      TaskListCache.datas.filter(list=>list.taskListType===currentType).forEach(list=>{
        list.ongoing.forEach(task=>result.push({value:task.text,taskCategoryId:task.taskCategoryId}));
        list.complete.forEach(task=>result.push({value:task.text,taskCategoryId:task.taskCategoryId}));
      })
      return result;
    }
} 
function getCategory(categoryDef){
  if(categoryDef.categoryId){
    var match = TaskCategoryCache.datas.filter(cat=>cat.systemCategoryId===categoryDef.categoryId);
    if(match) return match[0];  
  }else if(categoryDef.taskCategoryId){
    return FwDatas.get(categoryDef.taskCategoryId)
  }
  
}
function init(input){
  input.prop('autocomplete','off')
  let 
    dataSourcesString = input.attr('data-source').split(' '),
    allsuggestions,
    allsuggestionsPromises,
    position = input.position(),
    dimensions = {outerHeight:input.outerHeight(),outerWidth:input.outerWidth()},
    theNode = $(`<div class="selectable" style="font-size:${input.css('font-size')};font-weight:400;line-height:200%;display:none;cursor:pointer;z-index:12;background:var(--fwSurface);border:var(--border);border-radius:0 0 4px 4px;position:absolute;left:0;right:0;"></div>`);
  
  theNode.insertAfter(input);
  
  function initializeInput(callback){
    if(allsuggestionsPromises) {
      allsuggestionsPromises.then(callback);
      return;
    }
    allsuggestionsPromises = Promise.all(dataSourcesString.map(str=>datasource[str](input.metaId()))).then(function(arrayOfArray){
      allsuggestions = new TaskSuggestionSet();
      arrayOfArray.forEach(array=>allsuggestions.pushAll(array));
    }).then(callback);
  }
  
  function display(evt){
    
    var 
      text = input.val(),
      matchedSugg = [];
    if(allsuggestions && text.trim().length>0){
      matchedSugg = new Searcher()
        .filterSuggestion(text.trim(),allsuggestions.data)
        .slice(0,5);
    }  
    let paddingLeft = input.css('padding-left') 
    theNode.html(matchedSugg.map(sug=>{
      let 
        category = getCategory(sug),
        json = Html.escape(JSON.stringify({value:sug.value,categoryId:category?category.metaId:undefined})).replace("'","&apos;");
      
      return `<div data-json='${json}' style="padding-left:${paddingLeft}"><span>${sug.value}</span> <span style="font-size:80%;opacity:0.7">${category?category.name:''}</span></div>`
    }).join(''))
    if(matchedSugg.length){
      theNode.show();
    }else{
      theNode.hide();
    }
  }
  input.on('focus change input keypress paste', function(){
    initializeInput(display)
  })
  input.on('blur',function(){
    theNode.hide();
  })
  function pick(div){
    let json = JSON.parse(div.attr('data-json'));
    input.val(json.value);
    input.get(0).form.taskCategoryId.value = json.categoryId?json.categoryId:'';
  }
  input.on('keydown',function(event){
    let 
      down = event.keyCode===40,
      up = event.keyCode===38;
    if(event.keyCode===9 && theNode.find('div').length){
      event.preventDefault();
      if(event.shiftKey){
        up=true
      }else{
        down=true;
      }
    }
    if(down){
      var done = theNode.find('.selected').removeClass('selected').next().addClass('selected')
      if(!done.length){
        theNode.find('div').first().addClass('selected')
      }
      return;
    }
    if(up){
      var done = theNode.find('.selected').removeClass('selected').prev().addClass('selected')
      if(!done.length){
        theNode.find('div').last().addClass('selected')
      }
      return;
    }
    if(event.keyCode===10||event.keyCode===13){
      var selected = theNode.find('.selected').first();
      if(selected.length){
        pick(selected);
      }else if(this.value === theNode.find('span').first().text()){
        pick(theNode.find('div').first());
      }
    }  
    
  });
  
  theNode.delegate('div','mousedown',function(evt){
    pick($(this));
    $(input.get(0).form).trigger('submit')
  })

}
Html.registerWidget('widget/form/autocomplete',{init:init})
